// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduledCallSuccessPopup__title-ac9b93 {
  color: var(--base-110);
  font: var(--font-title-8);
  letter-spacing: var(--font-spacing-title-8);
  margin-bottom: 4px;
}

.ScheduledCallSuccessPopup__sub-title-ea4720 {
  color: var(--base-70);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  margin-bottom: 24px;
}

.ScheduledCallSuccessPopup__popup-d5e335 {
  flex: initial;
  min-height: initial;
  max-height: initial;
}

.ScheduledCallSuccessPopup__container-b6ad8f {
  margin: 0 24px 40px 24px;
}

.ScheduledCallSuccessPopup__popup-header-e247bc {
  border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/ScheduledCalls/ScheduledCallSuccessPopup/ScheduledCallSuccessPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,yBAAA;EACA,2CAAA;EACA,kBAAA;AACF;;AAEA;EACE,qBAAA;EACA,wBAAA;EACA,0CAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,mBAAA;AACF","sourcesContent":[".title {\n  color: var(--base-110);\n  font: var(--font-title-8);\n  letter-spacing: var(--font-spacing-title-8);\n  margin-bottom: 4px;\n}\n\n.sub-title {\n  color: var(--base-70);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  margin-bottom: 24px;\n}\n\n.popup {\n  flex: initial;\n  min-height: initial;\n  max-height: initial;\n}\n\n.container {\n  margin: 0 24px 40px 24px;\n}\n\n.popup-header {\n  border-bottom: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `ScheduledCallSuccessPopup__title-ac9b93`,
	"sub-title": `ScheduledCallSuccessPopup__sub-title-ea4720`,
	"subTitle": `ScheduledCallSuccessPopup__sub-title-ea4720`,
	"popup": `ScheduledCallSuccessPopup__popup-d5e335`,
	"container": `ScheduledCallSuccessPopup__container-b6ad8f`,
	"popup-header": `ScheduledCallSuccessPopup__popup-header-e247bc`,
	"popupHeader": `ScheduledCallSuccessPopup__popup-header-e247bc`
};
module.exports = ___CSS_LOADER_EXPORT___;
